import { browserStore } from '@/utils/browser-store'

/**
 * Which project this reader had open last, so returning to the customer area
 * lands them where they were instead of asking again.
 *
 * A per-viewer convenience and nothing more: it is read as a suggestion, and
 * every caller checks the id against the projects the server says they own.
 *
 * One store per reader — an advisor in a shadow view has a choice per customer
 * they look at, and the customer has their own. The key is built here rather
 * than handed in, because reader and writer agreeing on it is the only thing
 * that has to hold.
 */
const storeFor = (shadowUserId: number | undefined) =>
  browserStore<number>(
    `brickup:customer-project:${shadowUserId == null ? 'self' : `shadow-${shadowUserId}`}`,
    { validate: value => Number.isInteger(value) && (value as number) > 0 },
  )

export const rememberedProject = (shadowUserId?: number): number | null =>
  storeFor(shadowUserId).load()

export const rememberProject = (
  shadowUserId: number | undefined,
  projectId: number,
): void => storeFor(shadowUserId).save(projectId)
